import type { Dispatch, SetStateAction } from 'react';
import { createNamedContext } from '@/utils';
import type { ReducedFiltersContextValue } from './interfaces';

export const ReducedFiltersContext = createNamedContext<ReducedFiltersContextValue>(undefined, 'WorkspaceGlobalSearch.ReducedFilters.Context');
export const RowExpandedContext = createNamedContext<[boolean, Dispatch<SetStateAction<boolean>>]>(null, 'WorkspaceGlobalSearch.RowExpanded.Context');